import { Injectable } from '@angular/core';
import { BaseProvider } from '../../shared/providers/base-provider';
import { ViewModeNotifier } from '../notifiers/view-mode-notifier';
import { ViewModeState } from '../states/view-mode-state';

@Injectable({ providedIn: 'root' })
export class ViewModeProvider extends BaseProvider<ViewModeNotifier, ViewModeState> {
  constructor() {
    super(ViewModeNotifier);
  }
}
